import ISSUE from './consts/issue';

export const PURPOSE_OPTIONS = [
  { value: 1, text: '[1] 外籍新娘(台灣身份證有配偶)' },
  { value: 2, text: '[2] 商務人士' },
  { value: 3, text: '[3] 留學(學校)' },
  { value: 4, text: '[4] 依親' },
  { value: 5, text: '[5] 移工(公司、工廠、漁船…)' },
  { value: 6, text: '[6] 幫傭(XX宅、XXX之女傭)' },
  { value: 7, text: '[7] 看護(醫院、護理之家)' },
  { value: 8, text: '[8] 其他' },
];

export const ID_TYPES = [
  { value: 1, text: "[1] 居留證ARC(護照號碼)"},
  { value: 2, text: "[2] 台灣身份證"},
  { value: 3, text: "[3] 護照(護照號碼)"},
  { value: 4, text: "[4] 入出境許可證(許可證號)"},
  { value: 5, text: "[5] 長期/依親居留證(統一證號)"},
  { value: 6, text: "[6] 健保卡"},
  { value: 7, text: "[7] 入境台灣簽證(VISA)-長期"},
  { value: 77, text: "[77] 入境台灣簽證(VISA)-短期"},
  { value: 8, text: "[8] 外籍船員臨時停留許可證"},
  { value: 9, text: "[9] 台灣駕照"},
  { value: 10, text: "[10] 學生證"},
  { value: 11, text: "[11] 其他"},
];

export const NATIONALITY_OPTIONS = [
  // { text: "台灣(外)", value: 1, },
  { text: "菲律賓", value: 2, },
  { text: "越南", value: 3, },
  { text: "印尼", value: 4, },
  { text: "泰國", value: 5, },
  { text: "其他", value: 6, },
  { text: "中國", value: 7, },
  // { text: "台灣(本)", value: 8, },
  { text: "印度", value: 9, },
];

export const NATIONALITY_VALUE_MAPPINGS = {
  1: "台灣(外)",
  2: "菲律賓",
  3: "越南",
  4: "印尼",
  5: "泰國",
  6: "其他",
  7: "中國",
  8: "台灣(本)",
  9: "印度",
};

export const getNationalityOptions = function(items) {
  return NATIONALITY_OPTIONS.filter(national => items.some(item => national.text == item));
}

export const getNationalityText = function (value) {
  const nationality = NATIONALITY_OPTIONS.find(item => item.value === value);
  return nationality ? nationality.text : "-";
}

export const TYPES_MAPPING = {
  apply: "一般門號",
  upgrade: "升級",
  change: "換補卡",
}

export const STEP_OPTIONS = [
  {
    text: "待作業",
    value: "all",
  },
  {
    text: "核照",
    value: "verify",
  },
  {
    text: "一次登打",
    value: "first-key-in",
  },
  {
    text: "二次登打",
    value: "second-key-in",
  },
  {
    text: "比對有誤",
    value: "mismatch",
  },
  {
    text: "改語言",
    value: "language",
  },
  {
    text: "儲值",
    value: "send-pin",
  },
  {
    text: "審件",
    value: "review",
  }
];

export const getStepText = function (value) {
  const step = STEP_OPTIONS.find(step => step.value == value);
  return step ? step.text : '-';
}

export const APPLICATION_STATUS = {
  ON_HOLD: 'on-hold',
  SUBMITTED: 'submitted',
  IN_PROGRESS: 'in-progress',
  PENDING_PROVISION: 'pending-provision',
  PROVISIONED: 'provisioned',
  RETURNED: 'returned',
  PENDING_REVIEW: 'pending-review',
  HAS_ISSUE: 'has-issue',
  REJCETED: 'rejected',
  SUSPENDED: 'suspended',
};

export const APPLICATION_STATUS_OPTIONS = [
  {
    text: '全部',
    value: null,
  },
  {
    text: '暫存',
    value: APPLICATION_STATUS.ON_HOLD,
  },
  {
    text: '已送件',
    value: APPLICATION_STATUS.SUBMITTED,
  },
  {
    text: '登打中',
    value: APPLICATION_STATUS.IN_PROGRESS,
  },
  {
    text: '預計開通',
    value: APPLICATION_STATUS.PENDING_PROVISION,
  },
  {
    text: '已開通',
    value: APPLICATION_STATUS.PROVISIONED,
  },
  {
    text: '預計審件',
    value: APPLICATION_STATUS.PENDING_REVIEW,
  },
  {
    text: '已完成',
    value: APPLICATION_STATUS.RETURNED,
  },
  {
    text: '問題件',
    value: APPLICATION_STATUS.HAS_ISSUE,
  },
  {
    text: '已退卡',
    value: APPLICATION_STATUS.REJCETED,
  },
  {
    text: '停話',
    value: APPLICATION_STATUS.SUSPENDED,
  },
];

export const IMAGE_KEY_MAPPINGS = {
  signature: "電子簽名",
  person: "本人正面照",
  first_id_front: "第一證件照正面",
  second_id_front: "第二證件照正面",
  first_id_back: "第一證件照背面",
  labor_contract: "勞工契約",
  other: "其他",
  second_id_back: "第二證件照背面",
  immigration_pages: "入境章修改頁面",
  wrong_photos: "錯誤照片",
  uploaded: "未分類",
  contract: "中華合約",
  'contract-first-page': "中華合約-第一頁",
  'contract-third-page': "中華合約-第三頁",
  'contract-nicehenry': "九亨會員申請書",
}

export default {
  NATIONALITY_OPTIONS,
  TYPES_MAPPING,
  STEP_OPTIONS,
  ISSUE,
}
